import { InjectionToken } from '@angular/core';

import { DoodCreateOrderQuery, DoodValidateOrderQuery } from '@store/order/order.model';

/** Runtime VM emitted by `CartMerchantAmountBlock` data sources. */
export type CartMerchantAmountBlockViewModel = {
  orderValidateData: DoodValidateOrderQuery | DoodCreateOrderQuery | null;
  isOrderValidating: boolean;
  cartHasProduct: boolean;
  orderHasProduct: boolean;
};

export const CART_MERCHANT_AMOUNT_BLOCK_LOADING_VM: CartMerchantAmountBlockViewModel = {
  orderValidateData: null,
  isOrderValidating: true,
  cartHasProduct: false,
  orderHasProduct: false,
};

export interface CartMerchantAmountBlockDataSource {
  readonly vm$: import('rxjs').Observable<CartMerchantAmountBlockViewModel>;
}

export const CART_MERCHANT_AMOUNT_BLOCK_DATA_SOURCE =
  new InjectionToken<CartMerchantAmountBlockDataSource>('CART_MERCHANT_AMOUNT_BLOCK_DATA_SOURCE');
